module.exports = __webpack_public_path__ + "static/media/top_start@2x.2c47e78d.png";